import survey from './survey'

export default {
  survey,
  title: {
    management: '求职者关系管理',
    tag: {
      management: '标签管理',
      task: '任务管理',
      add: '新增标签',
      edit: '编辑标签',
      addTask: '新增任务',
      editTask: '编辑任务'
    },
    microsite: {
      management: '微网站管理',
      add: '新增微网站',
      edit: '编辑微网站'
    },
    talentFilterGroup: '人才库',
    campaign: {
      management: '活动管理',
      list: '活动列表',
      add: '新增活动',
      edit: '编辑活动',
      send: '发送活动',
      report: '活动报表',
      micrositeFormExport: '微网站表单导出'
    }
  },
  tab: '求职者关系管理',
  label: {
    pv: '浏览次数',
    application: '申请人数',
    tag: {
      tagName: '标签英文名称',
      tagCnName: '标签中文名称',
      judgingCriteria: '评判标准',
      conditionRule: '条件关系',
      setCondition: '设置条件',
      conditionNo: '条件 {number}：',
      taskName: '任务名称',
      taskStatus: '任务状态',
      tagList: '标签列表',
      taskStatusSuccess: '执行成功',
      taskStatusPadding: '待执行',
      taskStatusDoing: '执行中',
      systemOperator: '系统'
    },
    microsite: {
      pcOrMobile: '电脑/手机',
      micrositeName: '微网站名称',
      timeRange: '活动时间',
      jobIds: '职位',
      micrositeLink: '微网站链接',
      webEnLink: '电脑端（英文）',
      webCnLink: '电脑端（中文）',
      mobileEnLink: '手机端（英文）',
      mobileCnLink: '手机端（中文）',
      publish: '发布',
      visibility: '可见性',
      chatbot: '聊天机器人',
      share: '微信分享设置',
      shareImage: '微信分享图标',
      group: '分组',
      cnGroupName: '分组名称（中文）',
      enGroupName: '分组名称（英文）',
      addGroup: '添加微网站分组',
      editGroup: '编辑微网站分组'
    },
    talentFilterGroup: {
      creator: '创建者',
      private: '私有'
    },
    talent: {
      candidateStatus: {
        hot: '7天内申请',
        active: '30天内申请',
        warm: '90天内访问',
        potential: '未注册访客',
        cold: '90天内无活动'
      }
    },
    campaign: {
      name: '活动名称',
      microsite: '微网站',
      receiptEmail: '回执邮箱',
      date: '日期',
      copyLink: '请按CTRL+C复制地址',
      notificationHeader: '发送活动',
      shareConfigHeader: '微信分享设置',
      dateRange: '日期范围',
      emailDetail: '邮件详情'
    },
    campaignReport: {
      all: '全部阶段',
      title: '活动报表',
      sent: '发送',
      realSent: '实际送达',
      micrositePV: '微网站浏览量',
      jobPV: '职位浏览量',
      applied: '申请人数',
      screened: '进入筛选人数',
      interviewed: '进入面试人数',
      hired: '雇佣人数',
      newTalentCount: '新增人才数',
      potentialCandidateCount: '潜在候选人访问数',
      conversionRate: '转化率：{rate}%',
      export: '导出',
      wxDelivered: '微信送达',
      emailDelivered: '邮件送达',
      wxSent: '微信发送',
      emailSent: '邮件发送',
      onlyMicrosite: '仅微网站'
    },
    campaignNotification: {
      header: '发送活动：{name}',
      talentGroup: '人才分组',
      message: '微信消息',
      messageType: '消息类型',
      emailSubject: '邮件标题',
      messagePreview: '微信预览',
      emailContent: '邮件内容',
      alumniSearchType: '发送对象',
      portal: '活动入口',
      confirmSendDialogTitle: '确认发送？',
      confirmSendDialogContent: '这次活动你将发送给以下的人才库分组：\n{groupName}\n总计：{totalCount}人'
    },
    home: {
      talentPoolManagement: '人才库管理',
      campaignManagement: {
        campaign: '活动管理 - 活动',
        report: '活动管理 - 报表'
      },
      micrositeManagement: '微网站管理',
      tagManagement: '标签管理',
      surveyManagement: '求职者问卷管理',
      back: '返回'
    }
  },
  menu: {
    tag: '标签管理',
    task: '任务管理',
    talentFilterGroup: '人才库分组管理',
    micrositeManagement: '微网站管理',
    campaign: '活动管理 - 活动',
    report: '活动管理 - 报表'
  },
  placeholder: {
    keywords: '搜索',
    tag: {
      tagName: '请输入标签名称',
      tagList: '请选择标签',
      taskName: '请输入任务名称',
      condition: {
        relation: {
          less_salary: '最低',
          more_salary: '最高',
          less_work_years: '最少',
          more_work_years: '最多',
          less_age: '最低',
          more_age: '最高',
          intValue: '请输入数字',
          stringValue: '支持多个关键字。 输入后回车添加。',
          gender: '请选择性别'
        }
      }
    },
    microsite: {
      micrositeName: '请输入微网站名称',
      startDate: '请选择开始时间',
      endDate: '请选择结束时间',
      jobIds: '请选择职位',
      visibility: '请选择可见性',
      shareFriendsTitle: '发送给好友标题',
      shareMomentsTitle: '分享到朋友圈标题',
      shareDesc: '发送给好友内容',
      group: '请选择分组',
      groupName: '请输入分组名称'
    },
    talentFilterGroup: {
      keywordSearch: '搜索（分组名）'
    },
    campaign: {
      search: {
        keywords: '搜索活动',
        microsite: '微网站'
      },
      name: '请输入活动名称',
      microsite: '请选择微网站',
      receiptEmail: '请输入回执邮箱',
      startDate: '开始日期',
      endDate: '结束日期'
    },
    campaignReport: {
      searchCampaign: '搜索活动',
      searchMicrosite: '搜索微网站',
      category: '全部阶段',
      startDate: '开始日期',
      endDate: '结束日期'
    },
    campaignNotification: {
      talentGroup: '请选择人才分组',
      message: '请选择微信消息',
      wechatPreview: '微信预览',
      emailPreview: '邮件',
      emailSubject: '请输入邮件标题',
      emailContent: '请输入邮件内容',
      alumniType: '请选择发送对象'
    }
  },
  message: {
    tag: {
      tagName: '请输入标签名称',
      conditionRule: '请选择条件关系',
      conditions: '请至少添加一个条件',
      intValue: '请输入数字',
      keywordNotEmpty: '请输入条件',
      requestError: '请求异常, 请刷新后重试',
      deleteConfirm: '确定删除该标签吗?',
      taskName: '请输入任务名称',
      tagList: '请至少添加一个标签',
      taskDeleteConfirm: '确定删除该任务吗?'
    },
    microsite: {
      micrositeName: '请输入微网站名称',
      timeRange: '请选择活动时间',
      jobIds: '请选择职位',
      requestError: '请求异常, 请刷新后重试',
      deleteConfirm: '确定删除该微网站吗?',
      shareTip: '您可以在这里设置分享到微信朋友和朋友圈的图标及文字。微信分享图标不能小于300px x 300px； 当微信分享的标题或内容中包含占位符#COMPANY_NAME#时，分享内容会自动替换该属性。',
      wrongImageType: '错误的文件类型，只接受图片类型文件',
      wrongImageSize: '错误的文件大小，只接受小于{size}MB的文件',
      uploadError: '上传失败，请稍后再试',
      hasBindCampaign: '此微网站已被绑定活动!',
      deleteGroup: '确认删除该分组吗？',
      addSuccess: '添加成功',
      updateSuccess: '更新成功',
      deleteSuccess: '删除成功'
    },
    talentFilterGroup: {
      deleteConfirm: '确定删除该分组吗?'
    },
    campaign: {
      nameRequired: '请输入活动名称',
      micrositeRequired: '请选择微网站'
    },
    campaignNotification: {
      noMatchText: '无匹配数据',
      noDataText: '无数据',
      campaignRequired: '请选择一个活动',
      talentGroupRequired: '请选择一个分组',
      messageRequired: '请选择一条消息',
      emailContentRequired: '请输入邮件内容',
      notificationSent: '活动发送成功',
      notificationSentFailed: '消息发送失败, 请刷新后重试'
    },
    campaignReport: {
      wxDelivered: '微信送达：{count}',
      emailDelivered: '邮件送达：{count}',
      wxSent: '微信发送：{count}',
      emailSent: '邮件发送：{count}'
    }
  },
  btn: {
    addImage: '点击上传',
    tag: {
      add: '新增标签',
      enable: '激活',
      disable: '禁用',
      addCondition: '添加条件',
      task: '任务管理',
      addTask: '添加任务',
      back: '返回'
    },
    microsite: {
      add: '新增微网站',
      addGroup: '新增分组',
      yes: '是',
      no: '否',
      setMicrosite: '设置微网站',
      preview: '预览',
      saveAndEdit: '保存并设置微网站',
      switch: {
        on: '开',
        off: '关'
      }
    },
    campaign: {
      send: '发送活动',
      copyURL: '复制链接',
      qrCode: '二维码',
      report: '报表',
      export: '导出',
      cancel: '取消'
    }
  },
  option: {
    tag: {
      all: '符合全部条件',
      any: '符合任意条件',
      no: '无条件'
    },
    talentFilterGroup: {
      all: '全部',
      public: '公开',
      private: '私有',
      allCreator: '所有分组',
      my: '我的分组'
    },
    campaignNotification: {
      wechatAndEmail: '微信和邮件',
      email: '邮件',
      wechat: '微信'
    },
    alumniSearchTypeOption: {
      notInTalentPool: '不在人才库中',
      InTalentPool: '在人才库中',
      allInTalentPool: '所有前员工'
    }
  },
  condition: {
    name: {
      school: '学校',
      major: '专业',
      company: '公司',
      salary: '薪资',
      experience: '工作经验',
      age: '年龄',
      gender: '性别',
      work_years: '工作年限',
      location: '户口所在地/当前所在地',
      resume_keywords: '简历关键字'
    },
    relation: {
      equals: '等于',
      contains: '包含',
      more: '大于',
      less: '小于',
      between: '介于…之间',
      to: '至'
    }
  },
  tooltip: {
    talentFilterGroup: {
      generatingReport: '报告生成中...'
    }
  },
  micrositeVisibility: {
    I: '仅内部可见',
    E: '仅外部可见',
    IE: '内外部可见',
    A: '仅前员工可见'
  },
  chatbot: {
    on: '打开',
    off: '关闭'
  },
  tagTypes: {
    OPENED: '打开',
    SHARED: '分享',
    'APPLIED FOR': '申请',
    OTHERS: '其他',
    'SCREENED UNDER': '筛选',
    'INTERVIEWED UNDER': '面试',
    'HIRED UNDER': '雇佣',
    SKILLS: '技能',
    EDUCATION: '教育',
    WORK_EXPERIENCE: '职业',
    STABILITY: '稳定性',
    RISKS: '风险',
    SMART: '智能标签'
  }
}
